import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { changesPendingFlows, getDataFlow, loadData } from "../../../redux/actions/flows";
import { useDataAuth } from "../../../hooks/useDataAuth";
import { actionTypes } from "../../../redux/contants/actionTypes";
import { useNotification } from "../../../hooks/useNotification";
import { callApi, callApiFlow } from "../../../services/api.service";
import { ensureArray, ensureJsonObject } from "../../../utils/validateResponseApi";
import axios from "axios";

export const useManageFlows = () => {
    const dispatch = useDispatch();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const [dataLog, setDataLog] = useState(null);
    const [isChangeDataFlows, setIsChangeDataFlows] = useState(false);
    const [listSubTypesComponent, setlistSubTypesComponent] = useState([]);
    const {
        updatingFlows,
        deletingFlows,
        listSchemes,
        listFunctionsSchema,
        listTypesComponent,
        isErrorFetch,
        messageErrorFetch,
        flowInEdition
    } = useSelector(state => state.flows);

    useEffect(() => {
        dispatch(changesPendingFlows(isChangeDataFlows));
    }, [isChangeDataFlows]);

    const handleChangeFlow = (idFlow, key, value) => {
    }

    const setValeComponentFlowInEdition = (flowComp) => {
        const newFlowInEdition = { ...flowInEdition, component: flowComp };
        setIsChangeDataFlows(true);
        dispatch(loadData(actionTypes.floChangeFlowInEdition, newFlowInEdition));
    }

    const updateFlow = () => {
        const data = {
            id_flow: flowInEdition.id_flow,
            //Se deja de esta forma ya que cuando se consulta el flujo la propiedad component es stringify,
            //para que guarde correctamente, se parsea a json
            component: JSON.parse(flowInEdition.component)
            // component: JSON.parse(flowInEdition.component)
        }
        callApi("flow_alter", "UPDATE_COMPONENT", data, userSession.token)
            .then(({ data }) => {
                sendNotification({ msg: "Actualizado exitosamente.", variant: "success", });
                setIsChangeDataFlows(false);
            }).catch((e) => {
                sendNotification({ msg: "Ocurrio un error.", variant: "error" });
            })
    }

    const handleDeleteFlow = (id_flow) => {
        callApi("flow_alter", "DELETE", { id_flow }, userSession.token)
            .then(({ data }) => {
                sendNotification({ msg: "Eliminado exitosamente.", variant: "success", });
                setIsChangeDataFlows(false);
            })
            .catch((ex) => {
                sendNotification({ msg: "Ocurrio un error.", variant: "error" });
            });
    }

    const getSubTypesComponent = async (val) => {
        callApi("component_schema_select", "SELECT_SUBTYPE_COMPONENT", { type_component: val }, userSession.token)
            .then(({ data }) => {
                setlistSubTypesComponent(ensureArray(data));
            })
            .catch((ex) => {
            });
    };

    const handleSaveConfiguration = async (val) => {
        callApi("flow_alter", "UPDATE_CONFIGURATION", val, userSession.token)
            .then(({ data }) => {
                sendNotification({ msg: "Actualizado exitosamente.", variant: "success", });
            })
            .catch((ex) => {
            });
    };

    const getConfigurationFlow = async (id_flow) => {
        try {
            const { data } = await callApi(
                "flow_select",
                "SELECT_ID_FLOW_CONFIGURATION",
                { id_flow },
                userSession.token,
                { findOne: 'true' }
            );
            return data;
        } catch (ex) {
            return {};
        }
    };

    const getFlowLog = async (id_flow_log, id_flow) => {
        dispatch(getDataFlow(id_flow, userSession.token));
        let data = JSON.stringify({
            "id_flow": "900114098-LOG-FLOW-GET-JSON",
            "id_flow_log": id_flow_log
        });

        let config = {
            method: 'POST',
            url: 'https://r5ton9113k.execute-api.us-east-1.amazonaws.com/prod/rpa/flow/activate',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: `Bearer ${userSession.token}`
            },
            data: data
        };

        const response = await axios.request(config);
        if (response.status === 200) {
            const jsStr = atob(response.data);
            const jsn = JSON.parse(jsStr);
            setDataLog(jsn);
        } else {
            sendNotification({ msg: "Log no encontrado.", variant: "error", });
        }
    }

    return [{
        flowInEdition,
        isErrorFetch,
        messageErrorFetch,
        updatingFlows,
        deletingFlows,
        listSchemes,
        listFunctionsSchema,
        listTypesComponent,
        isChangeDataFlows,
        listSubTypesComponent,
        dataLog,
        setIsChangeDataFlows,
        handleDeleteFlow,
        handleChangeFlow,
        getDataFlow,
        setValeComponentFlowInEdition,
        updateFlow,
        getSubTypesComponent,
        handleSaveConfiguration,
        getConfigurationFlow,
        getFlowLog
    }];
}
